import React from "react";
import { ArrowRight } from "lucide-react";
import { researchImage, facilityImage, aboutImage, company } from "../mock";
import Reveal from "./Reveal";

function SplitSection({ id, overline, title, body, image, reverse, cta }) {
  return (
    <div className={`grid md:grid-cols-2 gap-10 md:gap-14 items-center ${reverse ? "md:[direction:rtl]" : ""}`}>
      <Reveal className="md:[direction:ltr]">
        <div className="relative">
          <div className="absolute -inset-3 rounded-3xl -z-10" style={{ background: "var(--brand-ice)" }} />
          <img src={image} alt={title} className="rounded-2xl object-cover w-full h-[300px] md:h-[420px] shadow-lg" />
        </div>
      </Reveal>
      <Reveal delay={120} className="md:[direction:ltr]">
        <p className="overline text-sm mb-1">{overline}</p>
        <h2 className="section-title text-3xl md:text-4xl mb-5">{title}</h2>
        <p className="text-slate-600 leading-relaxed mb-6">{body}</p>
        <a href="#contact" className="inline-flex items-center gap-2 font-semibold text-[color:var(--brand-blue)] hover:gap-3 transition-all">
          {cta} <ArrowRight size={18} />
        </a>
      </Reveal>
    </div>
  );
}

export default function ResearchDev() {
  return (
    <section id="research" className="bg-slate-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 space-y-24">
        {/* About */}
        <div id="about">
          <SplitSection
            overline="Who We Are"
            title="Global Brilliance, Local Excellence"
            body={`${company.name} is dedicated to delivering exceptional refrigeration products and maintaining industry leadership through an unwavering customer-centric approach. From bustling markets to serene boutiques, our reach knows no bounds.`}
            image={aboutImage}
            cta="Read more"
          />
        </div>

        <SplitSection
          overline="Research &"
          title="Development"
          body="Explore the driving force behind our company by stepping into our Research & Development world. Our passionate team of engineers, designers, and technical experts work in synergy to bring you cutting-edge refrigeration solutions, rigorously tested and certified for safety and performance."
          image={researchImage}
          cta="Read More"
          reverse
        />

        <SplitSection
          overline="State-of-the"
          title="Art Facilities"
          body="Our manufacturing excellence sets us apart. Facilities equipped with cutting-edge machinery and integrated automation foster innovation while embracing eco-friendly practices. Our skilled team, rigorous quality standards, and a culture of continuous improvement drive us to exceed customer expectations."
          image={facilityImage}
          cta="Read More"
        />
      </div>
    </section>
  );
}
